import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {i18nApi} from '@core/api/index'

Vue.use(VueI18n)

const loadedLanguages = []
let isMessagesLoaded = false;

function loadLocaleMessages() {
    if (document.hasOwnProperty('hamlet') && document.hamlet.translations) {
        let translations = {};
        translations[document.hamlet.language] = document.hamlet.translations;
        isMessagesLoaded = true;
        return translations;
    }

    const messages = {}
    let localStorageLocale = localStorage.getItem('locale');

    if (localStorageLocale) {
        let localStorageMessages = localStorage.getItem('translations');

        if (localStorageMessages) {
            loadedLanguages.push(localStorageLocale);
            messages[localStorageLocale] = JSON.parse(localStorageMessages);
        }
    }

    return messages
}

const supported = ['en', 'sv'];
let locale = localStorage.getItem('locale') || navigator.language.substring(0, 2);
if (!supported.includes(locale)) {
    locale = 'en';
}

export const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: loadLocaleMessages(),
});

if (!isMessagesLoaded) {
    document.hamlet.tPromise.then(translations => {
        i18n.setLocaleMessage(
            i18n.locale,
            translations
        );
    });
}

function setI18nLanguage(lang) {
    i18n.locale = lang
    localStorage.setItem('locale', lang);
    return lang
}

export function loadCurrentLanguageTranslations() {
    return i18nApi.getTranslations(i18n.locale).then(response => {
        localStorage.setItem('locale', i18n.locale);
        localStorage.setItem('translations', JSON.stringify(response.data.messages));
        loadedLanguages.push(i18n.locale);
        i18n.setLocaleMessage(i18n.locale, response.data.messages);
    });
}

export function updateTranslation(key, translations) {
    let translation = translations.find(t => t.language === i18n.locale);

    if (translation) {
        let messages = {};
        messages[key] = translation.translation;
        i18n.mergeLocaleMessage(i18n.locale, messages);
    }
}

export function loadLanguageAsync(lang) {
    // If the same language
    if (i18n.locale === lang && loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // let localStorageMessages = localStorage.getItem('translation.' + lang);
    //
    // if (localStorageMessages) {
    //     loadedLanguages.push(lang);
    //     i18n.setLocaleMessage(lang, JSON.parse(localStorageMessages));
    //     return Promise.resolve(setI18nLanguage(lang))
    // }

    return i18nApi.getTranslations(lang).then(response => {
        localStorage.setItem('locale', lang);
        localStorage.setItem('translations', JSON.stringify(response.data.messages));
        loadedLanguages.push(lang);
        i18n.setLocaleMessage(lang, response.data.messages);
        setI18nLanguage(lang);
    });
}
